/**
 * ScaleDisplay
 *
 * Shows the approximate map scale ratio based on current zoom level.
 * At zoom 13 the scale is roughly 1:50,000; it doubles/halves per zoom step.
 */

import React from 'react'

const REFERENCE_ZOOM = 13
const REFERENCE_SCALE = 50000

/**
 * Compute approximate scale denominator from zoom level.
 * Scale halves when you zoom in one level, doubles when you zoom out.
 *
 * @param {number} zoom
 * @returns {number}
 */
export function computeScale(zoom) {
  return Math.round(REFERENCE_SCALE * Math.pow(2, REFERENCE_ZOOM - zoom))
}

/**
 * Format a scale number with locale-aware thousands separators.
 *
 * @param {number} scale
 * @returns {string}
 */
function formatScale(scale) {
  return scale.toLocaleString('en-US')
}

/**
 * @param {{ zoom: number }} props
 */
export function ScaleDisplay({ zoom }) {
  const scale = computeScale(zoom)

  return (
    <div className="scale-bar" data-testid="scale-display">
      ~1:{formatScale(scale)}
    </div>
  )
}

export default ScaleDisplay
